import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_my_einvoice_request_rejection_internal_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  company_hdr_guid: fromDatatype.GuidDataFieldInterface;
  branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  to_irb_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_supplier_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_buyer_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  einvoice_doc_type: fromDatatype.VarcharDatatypeInterface;
  original_einvoice_validated_datetime: fromDatatype.TimestampTzDatatypeInterface;
  original_einvoice_txn_date: fromDatatype.TimestampTzDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  document_ref_no: fromDatatype.VarcharDatatypeInterface;
  wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
  wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
  processing_logic: fromDatatype.VarcharDatatypeInterface;
  system_requestor_status: fromDatatype.VarcharDatatypeInterface;
  system_checking_status: fromDatatype.VarcharDatatypeInterface;
  system_approval_status: fromDatatype.VarcharDatatypeInterface;
  system_processing_status: fromDatatype.VarcharDatatypeInterface;
  system_notification_status: fromDatatype.VarcharDatatypeInterface;
  request_submitted_datetime: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  reason: fromDatatype.VarcharDatatypeInterface;
  lhdn_cancellation_status: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_my_einvoice_request_rejection_internal_doc_hdr_RowClass
  implements bl_fi_my_einvoice_request_rejection_internal_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  company_hdr_guid: fromDatatype.GuidDataFieldInterface;
  branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  to_irb_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_supplier_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_buyer_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  einvoice_doc_type: fromDatatype.VarcharDatatypeInterface;
  original_einvoice_validated_datetime: fromDatatype.TimestampTzDatatypeInterface;
  original_einvoice_txn_date: fromDatatype.TimestampTzDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  document_ref_no: fromDatatype.VarcharDatatypeInterface;
  wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
  wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
  processing_logic: fromDatatype.VarcharDatatypeInterface;
  system_requestor_status: fromDatatype.VarcharDatatypeInterface;
  system_checking_status: fromDatatype.VarcharDatatypeInterface;
  system_approval_status: fromDatatype.VarcharDatatypeInterface;
  system_processing_status: fromDatatype.VarcharDatatypeInterface;
  system_notification_status: fromDatatype.VarcharDatatypeInterface;
  request_submitted_datetime: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  reason: fromDatatype.VarcharDatatypeInterface;
  lhdn_cancellation_status: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
